// extracted by css-extract-rspack-plugin
var _1 = "JvY8iFTUwdQ5VWke";
export { _1 as "labelStyle" }
// extracted by css-extract-rspack-plugin
var _1 = "JvY8iFTUwdQ5VWke";
export { _1 as "labelStyle" }
